import React from 'react';
import {
  Backdrop,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';

const LoadingOverlay = ({ 
  open, 
  message = 'Loading...', 
  sx = {},
  size = 40,
  color = 'primary'
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        ...sx,
      }}
      open={open}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
      >
        <CircularProgress 
          color={color} 
          size={size}
          thickness={4}
        />
        <Typography 
          variant="body1" 
          color="inherit"
          sx={{ fontWeight: 'medium' }}
        >
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LoadingOverlay;
